<template>
  <form-box
    title="农机作业"
    :button-text="type === 'check' ? '' : '增加农机作业'"
    @add="addAgricMachineInfo"
  >
    <template v-if="agricMachineInfoFormArr && agricMachineInfoFormArr.length">
      <div
        v-for="(item, index) in agricMachineInfoFormArr"
        :key="index"
        class="form-content"
      >
        <el-form
          :ref="`agricMachineInfoForm${index}`"
          class="form-box"
          size="medium"
          label-position="top"
          :rules="rules"
          :model="item"
        >
          <div class="delete-btn" v-if="type !== 'check'">
            <span @click="deleteAgricMachineInfo(index)"
              ><i class="el-icon-delete"></i>删除</span
            >
          </div>
          <div class="form-row">
            <!-- 左侧表单 -->
            <div class="form-column">
              <el-form-item label="农机经营年度" prop="year">
                <el-date-picker
                  v-model="item.year"
                  :disabled="type === 'check'"
                  type="year"
                  placeholder="选择农机经营年度"
                  format="yyyy 年"
                  value-format="yyyy"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="农机数量" prop="machineryNum">
                <el-input
                  v-model="item.machineryNum"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="5"
                  placeholder="请输入农机数量"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="农机作业利润" prop="profit">
                <el-input
                  v-model="item.profit"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="10"
                  placeholder="请输入农机作业利润"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
              <el-form-item label="农机价值" prop="costAmount">
                <el-input
                  v-model="item.costAmount"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="10"
                  placeholder="请输入农机价值"
                >
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </div>
            <!-- 右侧表单 -->
            <div class="form-column">
              <el-form-item label="农机手数量" prop="peopleNum">
                <el-input
                  v-model="item.peopleNum"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="5"
                  placeholder="请输入农机手数量"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="满负荷耕作面积" prop="acreage">
                <el-input
                  v-model="item.acreage"
                  :disabled="type === 'check'"
                  class="ipt"
                  maxlength="10"
                  placeholder="请输入满负荷耕作面积"
                >
                  <template slot="append">亩</template>
                </el-input>
              </el-form-item>
              <el-form-item label="是否为预计" prop="isEstimated">
                <el-select
                  :disabled="type === 'check'"
                  v-model="item.isEstimated"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in allSelectData.standardAcreStatusArr"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <Empty v-else emptyTxt="暂无农机信息" emptyImg="empty2.png"></Empty>
  </form-box>
</template>

<script>
import FormBox from "./FormBox.vue";
import Empty from "./Empty.vue";
export default {
  name: "PlantInfo",
  components: {
    FormBox,
    Empty,
  },
  props: {
    agricMachineInfoFormArr: {
      type: Array,
      default() {
        return [];
      },
    },
    allSelectData: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    const validateNumAndEmpty = (rule, value, callback) => {
      const pattern = /^\d{0,10}(\.\d{0,2})?$/g;
      if (value && !pattern.test(value)) {
        callback(
          new Error(`${rule.message}必须为数字（整数或保留两位小数）或者空`)
        );
      }
      callback();
    };
    const validateInteger = (rule, value, callback) => {
      if (value && !/^[1-9]\d*$/.test(value)) {
        return callback(new Error("请输入正整数"));
      }
      return callback();
    };
    return {
      rules: {
        peopleNum: [
          {
            trigger: "blur",
            validator: validateInteger,
          },
        ],
        machineryNum: [
          {
            trigger: "blur",
            validator: validateInteger,
          },
        ],
        acreage: [
          {
            trigger: "blur",
            message: "满负荷耕作面积必须为数字（整数或保留两位小数）",
            validator: validateNumAndEmpty,
          },
        ],
        profit: [
          {
            trigger: "blur",
            message: "农机作业利润必须为数字（整数或保留两位小数）",
            validator: validateNumAndEmpty,
          },
        ],
        costAmount: [
          {
            trigger: "blur",
            message: "农机价值必须为数字（整数或保留两位小数）",
            validator: validateNumAndEmpty,
          },
        ],
      },
    };
  },
  methods: {
    addAgricMachineInfo() {
      this.$emit("add", "machineryInfoDTOList");
    },
    deleteAgricMachineInfo(index) {
      this.$emit("delete", "machineryInfoDTOList", index);
    },
  },
};
</script>

<style scoped lang="scss">
.form-content {
  background: #f7f9fb;
  margin-bottom: 20px;
  .form-box {
    .delete-btn {
      text-align: right;
      font-size: 14px;
      color: #ff5c5c;
      padding: 18px 16px 0 0;
      span {
        cursor: pointer;
      }
      i {
        font-size: 18px;
        margin-right: 4px;
      }
    }
    .form-row {
      display: flex;

      .form-column {
        padding: 40px 0 30px 100px;
        flex: 1;
        ::v-deep .el-form-item__label {
          line-height: normal !important;
        }
        .ipt,
        .el-select,
        .el-date-editor {
          width: 374px;
        }
      }
    }
  }
}
</style>
